module.exports = __webpack_public_path__ + "img/2.b617a790.jpg";